module.exports = __webpack_public_path__ + "static/storm-giant-mtg_afr-d70294722c427c2710aefa09b2a2b510.jpg";